import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PupilContext } from '../../pupil-context';

export const PupilContextActions = createActionGroup({
  source: 'Pupil Context',
  events: {
    'Set Pupil Context': props<{ pupilContext: PupilContext | undefined }>(),
  },
});
